var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#TikTok--3bBwE';
                    var viewUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#view-TikTok--3bBwE';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };